<template>
  <v-layout class="short-control-toolbar image-browser-toolbar" align-center>
    <playback-controls 
      class="ml-auto mr-auto"
      :index="imageIndex" 
      :count="browserImages.length"
      :isPlaying="isPlaying"
      :playRate="playRate"
      @previous="previousImage"
      @next="nextImage"
      @play="play"
      @pause="pause"
      @setPlayRate="setPlayRate" />
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import playbackControls from "./PlaybackControls";
export default {
  name: "imagePlaybackToolbar",
  components: { playbackControls },
  computed: {
    ...mapGetters(["image", "browserImages", "imageIndex", "rgbView", "rgbExpanded", 
      "isOptos", "isPlaying", "playRate"]),
    rgbExpandedClass(){
      return "modal-cta" + (this.rgbExpanded ? " active" : "");
    },
    rgbCollapsedClass(){
      return "modal-cta ml-2" + (!this.rgbExpanded ? " active" : "");
    }
  },
  methods: {
    previousImage() {
      this.$store.dispatch("selectPreviousImage");
    },
    nextImage() {
      this.$store.dispatch("selectNextImage");
    },
    play() {
      this.$store.dispatch("playImages");
    },
    pause() {
      this.$store.commit("pause");
    },
    setPlayRate(rate){
      this.$store.commit("setPlayRate", rate);
    }
  }
};
</script>
